import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect }    from 'react-redux';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Checkbox,
  Radio,
  InputGroup,
  Badge,
  Image
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import {
  bindActionCreators,
  compose
}                     from 'redux';


import moment from 'moment';

import {
  Breadcrumb as BreadcrumbComponent
}                        from '../../../components';


import {addMarket} from '../../../redux/actions/emailManagerActions';
import NumberFormat from "react-number-format";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { createBrowserHistory } from "history";
const history = createBrowserHistory();

let isLoading = "false";
class Add extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props){
    super(props);
    this.state = {
      path: ['Home', 'Add Market'], 
      links: ["home",'/market/add'],
      market_name: '',
      org_id: '',
      prop_name: '',
      audienceId: '',
      audience_id: [],
      station_audience_id: '',
      address: '',
      sender_id: '',
      file: [],
      file_url: [],
      show: false,
      arrayValidate: true,
      from_name: '',
      reply_to: '',
    }
  this.handleSubmit = this.handleSubmit.bind(this);
	this.handleDismiss = this.handleDismiss.bind(this);
	this.handleShow = this.handleShow.bind(this);
	this.handleFormData = this.handleFormData.bind(this);
	this.Clear=this.Clear.bind(this);
  }
  
  handleFormData(e) {
    if (e.target.files && e.target.files.length > 0) {
    	let file_url = this.state.file_url;
    	let file = this.state.file;
    	for (var i = 0; i < e.target.files.length; i++) {
    		file_url.push(URL.createObjectURL(e.target.files[i]));
        file.push(e.target.files[i]);
    	}

    	this.setState({files: file_url, file: file});
    }
  }

	handleDismiss() {
		this.setState({ messageShow: false });
	}

	handleShow() {
		this.setState({ messageShow: true });
	}

	  handleChange = (e) => {
	  	if(`${e.target.name}Error` !== ''){
	      this.setState({[`${e.target.name}Error`]:''})
	    }
	  	this.setState({[e.target.name]: e.target.value});
	  }

  Clear(){
  	(this.state.state = ""),
  	(this.state.stateAbbr = ""),
  	(this.state.city = ""),
  	(this.state.cityID = ""),
  	(this.state.charity_name = ""),
  	(this.state.address1 = ""),
  	(this.state.address2 = ""),
  	(this.state.zipcode = ""),
  	(this.state.phone = ""),
  	(this.state.email = ""),
  	(this.state.status = "active");
  }

  componentWillMount(){
    this.props.clearAlert();
    this.handleDismiss();
  }

  componentWillReceiveProps(nextProps){
  	if(this.props.marketResponse !== nextProps.marketResponse){
  		if(nextProps.marketResponse){
  		  this.props.clearAlert();
          this.handleShow();
          if(nextProps.marketResponse.response == 'success'){
          	this.Clear();
          	this.onSelectedCountry();
            this.props.renderAlert("success", nextProps.marketResponse.message);
          }else{
            this.props.renderAlert("danger", nextProps.marketResponse.message);
          }
          window.scrollTo(0, 0);
          isLoading = "false";
  		}
  	}
  	if (this.props.error !== nextProps.error) {
	    if (nextProps.error) {
	      this.props.clearAlert();
	      this.handleShow();
	      this.props.renderAlert("danger", nextProps.error);
	      window.scrollTo(0, 0);
	      isLoading = "false";
	    }
	}
	if (nextProps.message) {
		this.handleShow();
		this.setState({
		  alertMessage: nextProps.message,
		  msgType: nextProps.alertType
		});
	}
  }

  validate = (e) => {
    let isError = false;

    if(!this.state.market_name){
      isError = true;
      this.setState({market_nameError:"red"})
    }

    if(!this.state.org_id){
      isError = true;
      this.setState({org_idError:"red"})
    }

    if(!this.state.prop_name){
      isError = true;
      this.setState({prop_nameError:"red"})
    }

    if(!this.state.audienceId && this.state.audience_id.length == 0){
      isError = true;
      this.setState({audienceIdError:"red"})
    }

    if(!this.state.from_name){
      isError = true;
      this.setState({from_nameError:"red"})
    }

    if(!this.state.reply_to){
      isError = true;
      this.setState({reply_toError:"red"})
    }
  

    if(this.state.audience_id){
      this.state.audience_id.map((data, index) => {
        if(!data){
          isError = true;
          this.setState({arrayValidate:false});
        }
      })
    }

    return isError;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let isError = this.validate();
    if(!isError){
    	isLoading = "true";
      this.setState({arrayValidate:true});
    	const formData = new FormData();
    	formData.append('market_name', this.state.market_name);
    	formData.append('org_id', this.state.org_id);
    	formData.append('prop_name', this.state.prop_name);
    	formData.append('audience_id', (this.state.audience_id.length > 0) ? JSON.stringify(this.state.audience_id) : JSON.stringify([this.state.audienceId]));
    	formData.append('station_audience_id', this.state.station_audience_id);
    	formData.append('address', (this.state.address) ? this.state.address : "");
    	formData.append('sender_id', this.state.sender_id);
      formData.append('from_name', this.state.from_name);
      formData.append('reply_to', this.state.reply_to);
    	if(this.state.file){
        let images = this.state.file;
        for(let img = 0; img < images.length; img++){
          formData.append("file["+img+"]", images[img]);
        }
      }

		this.props.addMarket(formData, 'campaign-market/add');
    }
  }
  onSelectedCountry  = (val, key) => {
	  this.setState({country:val});
	  this.setState({countryName:key});
    if (!this.state.country) {
      this.setState({ countryError: "" });
    }

	  if(this.state.country != val || typeof val !== 'undefined'){
	    this.setState({state: '', stateAbbr: '', city: '', cityID: ''});
	  }
  };

  onSelectedState = (val,key) => {
    this.setState({state:key})
    this.setState({stateAbbr:val})
  };

  onSelectedCity = (val,key) => {
   this.setState({city: val});
   this.setState({cityID: key});
   if(this.state.cityID.length === 0){
    this.setState({cityIDError:""})
   }
  }

  addAudianceId = (e) => {
  	if(!this.state.audienceId){
  		this.setState({audienceIdError: 'red'});
  	}else{
  		let audienceId = this.state.audience_id;
  		audienceId.push(this.state.audienceId);

  		this.setState({audience_id: audienceId, audienceId: ''});
  	}
  }

  updateAudianceId = (e) => {
  	let audienceId = this.state.audience_id;
  	let index = e.target.attributes.getNamedItem("data-index").value;

  	audienceId[index] = e.target.value;
  	this.setState({audience_id: audienceId, audienceId: ''});
  }

  removeAudienceId = (e) => {
  	let audienceId = this.state.audience_id;
  	let index = e.target.attributes.getNamedItem("data-index").value;

  	audienceId.splice(index, 1);
  	this.setState({audience_id: audienceId, audienceId: ''});
  }

  removeCurrentImage = (index) => {
    let file_url = this.state.file_url;
    let file = this.state.file;

    file_url.splice(index, 1);
    file.splice(index, 1);

    this.setState({file_url: file_url, file: file});
  }


  render() {
  return (
    <div className="col-lg-12 add-sub-admin">
    {isLoading == "true" ? (
      <div className="loader">
        <p className="loading-message">
          <i>Loading...</i>
        </p>
        <div className="spinner">
          <div className="dot1" />
          <div className="dot2" />
        </div>
      </div>
    ) : (
      ""
    )}
    <div className="row">
      <div className="col-xs-12">
         <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
      </div>
    </div>
    <form>
      <div className="panel">
          <header className="panel-heading">Add Market</header>
          <div className="panel-body">
          {this.state.messageShow &&
          this.state.alertMessage !== "" && (
            <div className="col-lg-12">
              <Alert
                bsStyle={this.state.msgType}
                onDismiss={this.handleDismiss}
              >
                <strong>Message:</strong>{" "}
                {this.state.alertMessage}
              </Alert>
            </div>
          )}
          <Row>
              <Col md={6} xs={12}>
                  <Row>
                      <Col md={12} xs={126}>
                      	<FormGroup>
                        <ControlLabel><span style={{color: "red"}}>*</span> Market Name:</ControlLabel>
                        <FormControl
                          type="text"
                          placeholder="Market Name"
                          value={this.state.market_name}
                          name="market_name"
                          onChange={this.handleChange}
                          style={{borderColor:this.state.market_nameError}}
                        />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={126}>
                      	<FormGroup>
                        <ControlLabel><span style={{color: "red"}}>*</span> Organizaion Id:</ControlLabel>
                        <FormControl
                          type="number"
                          placeholder="Organizaion Id"
                          value={this.state.org_id}
                          name="org_id"
                          onChange={this.handleChange}
                          style={{borderColor:this.state.org_idError}}
                        />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={126}>
                      	<FormGroup>
                        <ControlLabel><span style={{color: "red"}}>*</span> Property Name:</ControlLabel>
                        <FormControl
	                          type="text"
	                          placeholder="Property Name"
	                          value={this.state.prop_name}
	                          name="prop_name"
	                          onChange={this.handleChange}
	                          style={{borderColor:this.state.prop_nameError}}
	                      />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={126}>
                        <FormGroup>
                        <ControlLabel><span style={{color: "red"}}>*</span> Market Audience Id: <span className="text-danger">{(this.state.arrayValidate == false) ? "All Audience Id field are required." : ""}</span></ControlLabel>
					    <InputGroup>
					      <FormControl
	                          type="number"
	                          placeholder="Market Audience Id"
	                          value={this.state.audienceId}
	                          name="audienceId"
	                          onChange={this.handleChange}
	                          style={{borderColor:this.state.audienceIdError}}
	                      />
					      <InputGroup.Addon style={{cursor: 'pointer', backgroundColor: '#449d44', color: '#fff', borderColor: '#398439'}} onClick={this.addAudianceId}>
					        Add
					      </InputGroup.Addon>
					    </InputGroup>
					    
					  </FormGroup>
					  </Col>
                      {this.state.audience_id.length > 0 &&
				    	this.state.audience_id.map((value, index) => 
				    		<Col md={12} xs={12}>
					    		<FormGroup>
						    		<InputGroup>
								      <FormControl
				                          type="number"
				                          placeholder="Market Audience Id"
				                          value={value}
				                          data-index={index}
                                  name={`audience_id${index}`}
				                          onChange={this.updateAudianceId}
				                      />
								      <InputGroup.Addon data-index={index} onClick={this.removeAudienceId} className="btn-danger" style={{cursor: 'pointer', backgroundColor: '#d9534f', color: '#fff', borderColor: '#d43f3a'}}>
								        Remove
								      </InputGroup.Addon>
								    </InputGroup>
							    </FormGroup>
						    </Col>
				    	)
					   }
                      
                      
                      <Col md={12} xs={12}>
                      	<FormGroup>
                        <ControlLabel>Station Audience Id:</ControlLabel>
                        <FormControl
                          type="number"
                          placeholder="Station Audience Id"
                          value={this.state.station_audience_id}
                          name="station_audience_id"
                          onChange={this.handleChange}
                          style={{borderColor:this.state.station_audience_idError}}
                        />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={126}>
                      	<FormGroup>
                        <ControlLabel>Sender Id:</ControlLabel>
                        <FormControl
                          type="number"
                          placeholder="Sender Id"
                          value={this.state.sender_id}
                          name="sender_id"
                          onChange={this.handleChange}
                          style={{borderColor:this.state.sender_idError}}
                        />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={126}>
                      	<FormGroup>
                        <ControlLabel>Address:</ControlLabel>
                        <FormControl
                          type="text"
                          placeholder="Address"
                          value={this.state.address}
                          name="address"
                          onChange={this.handleChange}
                        />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <FormGroup>
                        <ControlLabel>From Name:</ControlLabel>
                        <FormControl
                          type="text"
                          placeholder="From Name"
                          value={this.state.from_name}
                          name="from_name"
                          onChange={this.handleChange}
                          style={{borderColor:this.state.from_nameError}}
                        />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <FormGroup>
                        <ControlLabel>Reply To:</ControlLabel>
                        <FormControl
                          type="email"
                          placeholder="Reply To"
                          value={this.state.reply_to}
                          name="reply_to"
                          onChange={this.handleChange}
                          style={{borderColor:this.state.reply_toError}}
                        />
                        </FormGroup>
                      </Col>
                  </Row>
              </Col>
              <Col md={6} xs={12}>
                  <Row>

                      <Col md={12} xs={12}>
                      	<FormGroup>
                        <ControlLabel>Logo:</ControlLabel>
                        <FormControl
			              type="file"
			              id="file"
			              multiple
			              onChange={this.handleFormData}
			            />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
	                      <Row>
	                      	{(this.state.file_url.length > 0) &&
	                      	  this.state.file_url.map((file, index) => 
		                      <Col key={index} md={3} xs={3}>
		                          <Image
		                            key={index}
		                            src={file}
		                            width="250px"
		                            thumbnail
		                          />
		                          <Badge
		                            bsStyle="danger"
		                            style={{
		                              top: "-6%",
		                              position: "absolute",
		                              right: "3%"
		                            }}
                                data-id={index}
                                onClick={this.removeCurrentImage.bind(this, index)}
		                          >
		                            <i className="glyphicon glyphicon-remove" />
		                          </Badge>
		                      </Col>
		                      )
		                    }
	                      </Row>
                      </Col>
                  </Row>
              </Col>
          </Row>
          <Row>
          <hr/>
          </Row>
          <Row>
            <Col md={12} xs={12}>
            	<Button bsStyle="default" className="pull-right" onClick={() => this.context.router.history.push('/market/list')}>Cancel</Button>
              	<Button bsStyle="success" className="pull-right" onClick={this.handleSubmit}>Save</Button>
            </Col>
          </Row>
          </div>
      </div>
    </form>
    </div>
  )
  }
}

const mapStateToProps = (state,ownProps) => {
    return {
      error: state.emailManagerReducer.error,
      marketResponse:  state.emailManagerReducer.marketResponse,
      alertType: state.alertsReducer.alertType,
      message: state.alertsReducer.message,
    };
};
export default compose(
  withRouter, 
  connect(mapStateToProps, {addMarket, renderAlert, clearAlert})
)(Add);


// WEBPACK FOOTER //
// ./src/app/views/admin/campaignMarket/Add.js